<template>
    <q-header reveal elevated class="bg-white text-black">
        <q-toolbar>
            <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
            <div class="header_lesson q-px-sm">
                <b>학습 분석리포트 - 추천학습 {{ studyStore.report?.level }}레벨 {{ studyStore.report?.lesson }}레슨</b>
            </div>
        </q-toolbar>
    </q-header>
    <q-page-container>
        <q-page>
            <div class="row">
                <div style="width: 25%; height: calc(100vh - 50px); background-color: #f6f6f6">
                    <div style="padding: 30px">
                        <div style="font-size: 20px; font-weight: bold">
                            <div style="font-size: 16px; color: #424242">{{ globalStore.userInfo.schoolName }} {{ globalStore.userInfo.student_grade_code }}학년</div>
                            <div>
                                <b>{{ globalStore.userInfo.studentName }}님의 독해력은</b>
                            </div>
                            <div>
                                <b
                                    ><span style="color: #00a2e0; font-weight: bold">
                                        {{ summaryData?.totalAccuracyRate > 80 ? '우수한' : summaryData?.totalAccuracyRate > 50 ? '평균' : '낮은' }}
                                        수준</span
                                    >입니다!</b
                                >
                            </div>
                        </div>
                        <div style="padding: 15px 0px; display: flex; justify-content: space-between; position: relative; align-items: center">
                            <div style="align-items: center; display: flex"><q-icon name="calendar_today" /> {{ moment().format('YYYY-MM-DD') }}</div>
                        </div>
                        <div style="width: 100%; justify-content: center; position: relative; display: inline-flex">
                            <div style="width: 400px; height: 200px; max-width: 400px">
                                <GaugeChart v-if="summaryData?.totalAccuracyRate" :chartData="summaryData?.totalAccuracyRate" />
                            </div>
                        </div>
                        <div v-if="summaryData" class="item-box" style="background-color: white">
                            <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
                                <div><b>코어독해</b></div>
                                <div style="margin-left: 10px; color: #00a2e0; font-weight: bold">{{ summaryData.coreResult }}%</div>
                            </div>
                            <div style="display: flex; align-items: center">
                                <q-linear-progress rounded size="lg" :value="summaryData.coreResult / 100" color="primary" />
                            </div>
                            <div style="display: flex; justify-content: space-between; margin: 10px 0px">
                                <div><b>본격독해</b></div>
                                <div style="margin-left: 10px; color: #00a2e0; font-weight: bold">{{ summaryData.earnestResult }}%</div>
                            </div>
                            <div style="display: flex; align-items: center">
                                <q-linear-progress rounded size="lg" :value="summaryData.earnestResult / 100" color="primary" />
                            </div>
                            <div style="display: flex; justify-content: space-between; margin: 10px 0px">
                                <div><b>어휘학습</b></div>
                                <div style="margin-left: 10px; color: #00a2e0; font-weight: bold">{{ summaryData.vocabularyResult }}%</div>
                            </div>
                            <div style="display: flex; align-items: center">
                                <q-linear-progress rounded size="lg" :value="summaryData.vocabularyResult / 100" color="primary" />
                            </div>
                            <!-- <div style="display: flex; justify-content: space-between;">
              <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                <q-chip size="sm">지문1</q-chip>{{ passageList && passageList[0].topic ? passageList[0].topic : '' }}
              </div>
              <div style=" display: flex;"><img src="/assets/images/icon/icon_kread.svg" style="width: 50px;" />
                <div v-if="passageList && passageList[0].kreadScore && passageList[0].kreadScore !== ''"
                  style="background-color: #1976D2;color: white; border-radius: 50%;margin-left: 10px; padding:3px 8px; ;">
                  {{ passageList[0].kreadScore }}</div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; margin-top: 10px;">
              <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                <q-chip size="sm">지문2</q-chip>{{ passageList && passageList[1].topic ? passageList[1].topic : '' }}
              </div>
              <div style=" display: flex;"><img src="/assets/images/icon/icon_kread.svg" style="width: 50px;" />
                <div v-if="passageList && passageList[1].kreadScore && passageList[1].kreadScore !== ''"
                  style="background-color: #1976D2;color: white; border-radius: 50%;margin-left: 10px; padding:3px 8px; ;">
                  {{ passageList[1].kreadScore }}</div>
              </div>
            </div> -->
                        </div>
                    </div>
                    <!-- <qbankHeaderVue :v-if="questionHeader" :questionHeader="questionHeader" /> -->
                </div>
                <div style="width: 75%; height: calc(100vh - 50px)">
                    <q-scroll-area ref="scrollAreaRef" visible style="height: 100%; padding: 0px 10px">
                        <div style="padding: 30px 30px 0px">
                            <!-- <div class="title">
              학습 분석 결과
            </div>
            <div class="" style="border-radius: 0; box-shadow:none">
              <div class="row">
                <div class="col-6" style="padding: 10px;">
                  <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">사고 유형별 강약점</div>
                  <div class="summary_box">
                    <div style="margin: 10px 0px 10px">
                      <q-chip>우수</q-chip> 사실적 독해
                    </div>
                    <div style="margin: 10px 0px 10px">
                      <q-chip>취약</q-chip> 비판적적 독해
                    </div>
                  </div>

                </div>
                <div class="col-6" style="padding: 10px;">
                  <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">질문 유형별 강약점</div>
                  <div class="summary_box">
                    <div style="margin: 10px 0px 10px">
                      <q-chip>우수</q-chip> &lt;보기&gt;가 있는 문항
                    </div>
                    <div style="margin: 10px 0px 10px">
                      <q-chip>취약</q-chip> 부정형 질문
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding: 20px; font-size: 18px; line-height: 30px;">
                지문 읽기 활동에서 <b>(4. '윤리의 이해' 지문 읽기 시간은 권장 읽기 시간을 초과하였습니다. 지문을 집중하면서 읽으면서 시간을 단축시키는 연습이 필요합니다. 지문을 여러 번
                  읽으며 처음 지문 읽을 때 걸린 시간과
                  다회독 때 읽은 시간을 비교해 보면서 지문 읽기 시간을 줄이는 훈련을 해 보세요.)</b><br />
                지문 이해 활동을 살펴보면, <b>(5. 핵심 소재를 파악하는 능력은 갖추었으나, 주제를 찾고 핵심 표현을 정리하는 훈련이 필요합니다. 주제를 잘 파악하기 위해서는 중심 내용을
                  구조화하여 단락별 핵심내용을 찾는 연습을
                  꾸준히 해 보세요.)</b><br />
                본격독해에서 풀이한 문항 유형별 문제 해결력을 살펴보면, <b>(6. 사실적 독해, 비판적독해, &lt;보기&gt;가 없는 문항) 유형의 문제 해결력은 우수하나, (7. 글 부분에 대한
                  이해, 부정형질문) 유형에 약합니다. 반복해서
                  틀리는 문제의 유형을 명확히 파악하고, 유사한 형태의 문제를 매일 일정량 훈련하면 문제 해결력을 향상시킬 수 있습니다.</b>
              </div>
            </div> -->
                            <br />
                            <div class="title">학습 상세 내역</div>
                            <div style="margin-bottom: 10px">
                                <q-tabs v-model="tab" class="tab-passage">
                                    <q-tab name="passage1" label="지문1" />
                                    <q-tab name="passage2" label="지문2" />
                                </q-tabs>
                                <!-- <q-btn-toggle v-model="model" spread no-caps rounded unelevated toggle-color="primary" color="white"
                text-color="black" style="border:2px solid #00A2E0;" :options="[
                  { label: '지문1-인문', value: '1' },
                  { label: '지문2-정치 사회', value: '2' }
                ]" /> -->
                            </div>
                            <q-tab-panels v-model="tab">
                                <q-tab-panel v-for="(item, index) in passageList" :name="'passage' + (index + 1)">
                                    <div class="item-box">
                                        <div style="color: #8e8e8e; margin-bottom: -10px">
                                            {{ item?.topic }}
                                        </div>
                                        <div style="display: flex; position: relative; align-items: center; justify-content: space-between">
                                            <div style="font-size: 20px; font-weight: bold">{{ item.passageName }}</div>
                                            <div style="display: flex; position: relative; align-items: center">
                                                <div v-if="item && item?.kreadScore && item?.kreadScore !== ''" style="padding: 10px 20px; background-color: #effbff; border-radius: 20px; height: 50px; margin-right: 10px">
                                                    <div style="display: flex">
                                                        <img src="/assets/images/icon/icon_kread.svg" style="width: 50px" />
                                                        <div style="background-color: #1976d2; color: white; border-radius: 50%; margin-left: 10px; padding: 3px 8px; font-size: 16px">
                                                            {{ item?.kreadScore }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="padding: 10px 20px; background-color: #effbff; border-radius: 20px; height: 50px; align-items: center; display: flex">
                                                    <div style="font-size: 16px; font-weight: bold">성취율 {{ item.accuracyRate }}%</div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div style="display: flex; position: relative; align-items: center; justify-content: space-between; margin-bottom: 10px">
                                            <div style="font-size: 16px; font-weight: bold">코어독해</div>
                                            <div style="display: flex; position: relative; align-items: center">
                                                <div v-if="item?.coreElapsedTime">학습 시간 : {{ getTimeStringSecondsKor(item?.coreElapsedTime) }}</div>
                                            </div>
                                        </div>
                                        <div class="sub-title">⦁ 지문 읽기 활동</div>
                                        <q-markup-table flat class="summary-table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">나의 읽기 시간</th>
                                                    <th class="text-center">결과</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        <div>
                                                            <b>{{ getTimeStringSecondsKor(item.coreResult.readingResult.passageReadTime) }}</b>
                                                            <div>권장 읽기 시간: {{ getTimeStringSecondsKor(item.coreResult.readingResult.solveTime) }}</div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <span
                                                            :style="
                                                                item.coreResult.readingResult.passageReadTime > item.coreResult.readingResult.solveTime || item.coreResult.readingResult.passageReadTime < 30
                                                                    ? 'color:#EF2B2A;font-weight: bold;'
                                                                    : 'font-weight: bold;'
                                                            "
                                                        >
                                                            {{ item.coreResult.readingResult.passageReadTime < 30 ? '주의' : item.coreResult.readingResult.passageReadTime > item.coreResult.readingResult.solveTime ? '시간 초과' : '시간 준수' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </q-markup-table>
                                        <br />
                                        <div class="sub-title">⦁ 지문 이해 활동</div>
                                        <q-markup-table flat class="summary-table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">내용</th>
                                                    <th class="text-center" style="width: 80px">정답여부</th>
                                                    <th class="text-center" style="width: 80px">풀이화면</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="tData in item.coreResult?.understandingResult">
                                                    <td class="text-left">
                                                        {{ tData.content }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ tData.content.indexOf('구조화') !== -1 ? '완료' : '' }}
                                                        <q-icon v-if="tData.content.indexOf('구조화') === -1" :name="tData.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm" :style="tData.correctYn === false ? 'color:#FD6956 ;' : ''">
                                                        </q-icon>
                                                    </td>
                                                    <td class="text-center"><u>보기</u></td>
                                                </tr>
                                            </tbody>
                                        </q-markup-table>
                                        <br />
                                        <div style="display: flex; position: relative; align-items: center; justify-content: space-between; margin-bottom: 10px">
                                            <div style="font-size: 16px; font-weight: bold">본격독해</div>
                                            <div style="display: flex; position: relative; align-items: center">
                                                <div>학습 시간 : {{ getTimeStringSecondsKor(item.earnestElapsedTime) }}</div>
                                            </div>
                                        </div>
                                        <q-markup-table flat class="summary-table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">유형</th>
                                                    <th class="text-center">내용</th>
                                                    <th class="text-center" style="width: 80px">문항난이도</th>
                                                    <th class="text-center" style="width: 80px">정답여부</th>
                                                    <th class="text-center" style="width: 80px">풀이화면</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="vData in Object.values(item.earnestResultList)">
                                                    <tr v-for="(tItems, index) in vData">
                                                        <td v-if="index === 0" class="text-left" :rowspan="vData.length">
                                                            {{ tItems.analysisName }}
                                                        </td>
                                                        <td class="text-left">
                                                            <div style="color: #8e8e8e">{{ tItems.problemClassCode === '1' ? '기준문제' : '드릴문제' }}</div>
                                                            <div>{{ tItems.learningConceptDetailName }}</div>
                                                        </td>
                                                        <td class="text-center">
                                                            <q-chip size="sm" :style="tItems.difficultCode === '04' ? 'background-color:#EDEDED;' : tItems.difficultCode === '05' ? 'background-color:#FFD8D8 ;' : 'background-color:#D8F6FF;'">
                                                                {{ difficult[tItems.difficultCode]?.label }}
                                                            </q-chip>
                                                        </td>
                                                        <td class="text-center">
                                                            <q-icon :name="tItems.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm" :style="tItems.correctYn === false ? 'color:#FD6956 ;' : ''"> </q-icon>
                                                        </td>
                                                        <td class="text-center"><u>보기</u></td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                            <!-- <tbody>
                      <tr>
                        <td class="text-center" rowspan="3">
                          사실전 독해
                        </td>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">기준문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#D8F6FF ;">기초</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#FFD8D8 ;">심화</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="close" size="sm" style="color:#FD6956"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#EDEDED ;">핵심</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-center" rowspan="3">
                          비판적 독해
                        </td>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">기준문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#D8F6FF ;">기초</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="close" size="sm" style="color:#FD6956"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#FFD8D8 ;">심화</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#EDEDED ;">핵심</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-center" rowspan="3">
                          추론적 독해
                        </td>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">기준문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#D8F6FF ;">기초</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#FFD8D8 ;">심화</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#EDEDED ;">핵심</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-center" rowspan="3">
                          사실적 독해
                        </td>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">기준문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#D8F6FF ;">기초</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#FFD8D8 ;">심화</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                      <tr>
                        <td class="text-left">
                          <div style="color:#8E8E8E;">드릴문제</div>
                          <div>문맥을 통한 핵심 정보의 의미 추론</div>
                        </td>
                        <td class="text-center">
                          <q-chip size="sm" style="background-color:#EDEDED ;">핵심</q-chip>
                        </td>
                        <td class="text-center">
                          <q-icon name="radio_button_unchecked" size="sm"></q-icon>
                        </td>
                        <td class="text-center"><u>보기</u></td>
                      </tr>
                    </tbody> -->
                                        </q-markup-table>
                                        <br />
                                        <div style="display: flex; position: relative; align-items: center; justify-content: space-between; margin-bottom: 10px">
                                            <div style="font-size: 16px; font-weight: bold">어휘학습</div>
                                            <div style="display: flex; position: relative; align-items: center">
                                                <div>학습 시간 : {{ getTimeStringSecondsKor(item.vocabularyElapsedTime) }}</div>
                                            </div>
                                        </div>
                                        <q-markup-table flat class="summary-table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">내용</th>
                                                    <th class="text-center" style="width: 80px">정답여부</th>
                                                    <th class="text-center" style="width: 80px">풀이화면</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="tData in item?.vocabularyResultList">
                                                    <td class="text-left">
                                                        {{ tData.content }}
                                                    </td>
                                                    <td class="text-center">
                                                        <q-icon :name="tData.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm" :style="tData.correctYn === false ? 'color:#FD6956 ;' : ''"> </q-icon>
                                                    </td>
                                                    <td class="text-center"><u>보기</u></td>
                                                </tr>
                                            </tbody>
                                        </q-markup-table>
                                    </div>
                                </q-tab-panel>
                            </q-tab-panels>
                            <div style="text-align: center; margin-bottom: 10px">
                                <CqBtn size="lg" color="primary" label="학습이어하기" @onClickFn="movePg('corereading')" style="margin-right: 10px" />
                                <CqBtn size="lg" color="primary" label="학습 홈" @onClickFn="movePg('learninghome')" style="margin-left: 10px" />
                            </div>
                        </div>
                    </q-scroll-area>
                    <!-- <qbankHeaderVue :v-if="questionHeader" :questionHeader="questionHeader" /> -->
                </div>
            </div>
        </q-page>
    </q-page-container>
</template>

<script setup>
import StudyHeader from '@/components/layouts/header/studyHeader.vue';
import GaugeChart from '@/components/chart/gaugeChart.vue';
import { onMounted, ref, watch } from 'vue';
import { getUserJson, postUserJson } from '@/api/modules/login';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { getReportArea } from '@/api/modules/study';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, timeStringSecondsKorToSec } from '@/helpers/utils';
import { testData } from './testData';
import { useRouter } from 'vue-router';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { difficult } from '@/helpers/qbankParser/qbankMeta';
import moment from 'moment';
import { useQuasar } from 'quasar';

const $q = useQuasar();
const coreProcess = ref(0.5);
const model = ref('1');
const user = ref(null);
const tab = ref('passage1');
const globalStore = GlobalStore();
const studyStore = StudyStore();
const summaryData = ref(null);
const passageList = ref([]);
const router = useRouter();

const tdata = { Dtm: '2023-01-04 08:20:37', endDtm: '2023-01-04 09:20:16', testPaperName: '비문학_시험지_1_1', type: 'N', questionCode: '100', version: '1.0.11' };

const onClick = () => {
    postUserJson(JSON.stringify(tdata), (rs) => {
        console.log(rs);
    });
};

const onClick1 = () => {
    getUserJson((rs) => {
        console.log(rs);
    });
};

onMounted(() => {
    // summaryData.value = {
    //   totalAccuracyRate: testData.totalAccuracyRate,
    //   coreResult: testData.totalLearningResult.coreResult,
    //   earnestResult: testData.totalLearningResult.earnestResult,
    //   vocabularyResult: testData.totalLearningResult.vocabularyResult,
    // }
    // passageList.value = testData.passageList
    passageList.value = [];
    getReportArea({ ...studyStore.report }, (rs) => {
        summaryData.value = {
            totalAccuracyRate: rs.totalAccuracyRate,
            coreResult: rs.totalLearningResult.coreResult,
            earnestResult: rs.totalLearningResult.earnestResult,
            vocabularyResult: rs.totalLearningResult.vocabularyResult,
        };
        // 본격독해 그리기 위한 데이터 변경
        rs.passageList.forEach((ei) => {
            let tmpItems = ei;
            let tmpEarnestResultList = {};
            ei.earnestResultList.forEach((eii) => {
                let temp = tmpEarnestResultList[eii.analysisId] ? tmpEarnestResultList[eii.analysisId] : [];
                temp = [...temp, eii];
                tmpEarnestResultList = { ...tmpEarnestResultList, [eii.analysisId]: temp };
            });
            tmpItems = { ...tmpItems, earnestResultList: tmpEarnestResultList };
            passageList.value = [...passageList.value, tmpItems];
        });
        // console.log(passageList.value);
        // passageList.value = rs.passageList
    });
    // console.log(_.isEmpty(globalStore.userInfo));
    if (_.isEmpty(globalStore.userInfo)) {
        globalStore.getUserInfo();
        // console.log(globalStore.getUserInfo());
    }
    user.value = globalStore.userInfo;
});

const movePg = (pg) => {
    router.push('/' + pg);
};

const onClickHome = () => {
    // store.openConfirmDialog({
    //     message: '학습을 중단하고 홈으로 이동하시겠습니까?',
    //     cancel: '닫기',
    //     ok: '확인',
    //     callback: checkConfirm,
    // });
    $q.dialog({
        title: '확인',
        message: '학습을 중단하고 홈으로 이동하시겠습니까?',
        // ok: {
        //   push: true,
        //   style: 'width:40%;'
        // },
        // cancel: {
        //   push: true,
        //   color: 'red',
        //   outline,
        //   style: 'width:40%;'
        // },
        cancel: true,
        persistent: true,
    })
        .onOk(() => {
            checkConfirm(true);
        })
        .onCancel(() => {
            // console.log('>>>> Cancel')
        });
};
</script>

<style scoped lang="scss">
.sub-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
}

.title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
}

.summary_box {
    // display: flex;
    // background-color: #F6F6F6;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 10px;
}

.summary-table {
    border-top: 1px solid #8e8e8e;
    border-bottom: 1px solid #8e8e8e;
    border-radius: 0px;

    thead {
        background-color: #ededed;
    }
}

.item-box {
    // display: flex;
    // border: 1px solid #E0E0E0;
    // border-radius: 10px;
    padding: 20px;
}

.tab-passage {
    .q-tab {
        width: 50%;
    }

    ::v-deep .q-tab__label {
        color: #00a2e0;
    }

    .q-tab--active {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-top: 2px solid #00a2e0;
        border-left: 2px solid #00a2e0;
        border-right: 2px solid #00a2e0;
        border-bottom: none;
    }

    ::v-deep .q-tab__indicator {
        display: none !important;
    }

    ::v-deep .q-tab--inactive {
        border-bottom: 2px solid #00a2e0;

        .q-tab__label {
            color: #bdbdbd;
        }
    }
}
::v-deep {
    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}
</style>
